import { filtersToQuery, useFilters } from '@web/utility/hooks/useFilters';
import { preserveDriveSearchSubAction } from '@web/utility/preserveDriveSearchSubAction';
import { useLocation, useNavigate } from 'react-router-dom';
export function useNavigateTo() {
    var navigate = useNavigate();
    var filters = useFilters();
    var location = useLocation();
    return function navigateTo(_a) {
        var pathname = _a.pathname, _b = _a.newFilters, newFilters = _b === void 0 ? {} : _b, _c = _a.resetScroll, resetScroll = _c === void 0 ? true : _c;
        var targetPathname = pathname !== null && pathname !== void 0 ? pathname : location.pathname;
        var newFilterKeys = Object.keys(newFilters);
        var isSamePath = targetPathname === location.pathname;
        var isPaginationOnlyChange = newFilterKeys.length === 1 && newFilterKeys[0] === 'page';
        var shouldPreserveScroll = isSamePath && newFilterKeys.length > 0 && !isPaginationOnlyChange;
        var updatedFilters = preserveDriveSearchSubAction(filters, newFilters, location.search);
        if (Object.keys(newFilters).length > 0 &&
            !newFilters.hasOwnProperty('page')) {
            updatedFilters.page = 1;
        }
        if (!newFilters.hasOwnProperty('docSearch')) {
            updatedFilters.docSearch = null;
        }
        if (shouldPreserveScroll) {
            updatedFilters.scrollY = Math.round(window.scrollY || window.pageYOffset || 0);
        }
        else {
            updatedFilters.scrollY = null;
        }
        var query = filtersToQuery(updatedFilters, location.search);
        navigate("".concat(targetPathname, "?").concat(query), { replace: false });
        if (resetScroll && !shouldPreserveScroll) {
            window.scrollTo(0, 0);
        }
    };
}
